/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { QuoteTemplateShareButton_QuoteTemplateFragmentDoc } from './buttons/QuoteTemplateShareButton.generated.js';
import { QuoteTemplateUnshareFromStoreButton_QuoteTemplateFragmentDoc } from './buttons/QuoteTemplateUnshareFromStoreButton.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TemplatesQuoteTemplateManageVersionsModalQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type TemplatesQuoteTemplateManageVersionsModalQuery = { quoteTemplateLatest: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'QuoteTemplateLatestResult', quoteTemplate?: { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null, hasAnyPublishedVersion: boolean, containsUnpublishedChanged: boolean, latestPublishedVersionNumber?: number | null, hasSubscriptionToTemplate: boolean, publishedVersions: Array<{ __typename: 'PublishedVersion', id: string, versionNumber: number, createdAt: any }>, templateSharing?: { __typename: 'TemplateSharing', id: string, latestSharedVersionNumber: number, sharedPublicly: boolean, templateId: string, subscribedToTemplate?: { __typename: 'TemplateSubscription', subscribedVersionNumber: number, updateAvailable: boolean } | null, sharedWithOrganisations: Array<{ __typename: 'Company', id: string, title: string, logo: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } }> } | null } | null } };

export type PublishedVersionFragment = { __typename: 'PublishedVersion', id: string, versionNumber: number, createdAt: any };

export const PublishedVersionFragmentDoc = gql`
    fragment PublishedVersion on PublishedVersion {
  id
  versionNumber
  createdAt
}
    `;
export const TemplatesQuoteTemplateManageVersionsModalDocument = gql`
    query TemplatesQuoteTemplateManageVersionsModal($id: ID!) {
  quoteTemplateLatest(id: $id) {
    ... on QuoteTemplateLatestResult {
      quoteTemplate {
        id
        resolvedAsReadModelVersionNumber
        hasAnyPublishedVersion
        containsUnpublishedChanged
        publishedVersions {
          id
          ...PublishedVersion
        }
        templateSharing {
          id
          latestSharedVersionNumber
          sharedPublicly
          subscribedToTemplate {
            subscribedVersionNumber
            updateAvailable
          }
          sharedWithOrganisations {
            id
          }
        }
        ...QuoteTemplateShareButton_QuoteTemplate
        ...QuoteTemplateUnshareFromStoreButton_QuoteTemplate
      }
    }
  }
}
    ${PublishedVersionFragmentDoc}
${QuoteTemplateShareButton_QuoteTemplateFragmentDoc}
${QuoteTemplateUnshareFromStoreButton_QuoteTemplateFragmentDoc}`;

/**
 * __useTemplatesQuoteTemplateManageVersionsModalQuery__
 *
 * To run a query within a React component, call `useTemplatesQuoteTemplateManageVersionsModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplatesQuoteTemplateManageVersionsModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplatesQuoteTemplateManageVersionsModalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTemplatesQuoteTemplateManageVersionsModalQuery(baseOptions: Apollo.QueryHookOptions<TemplatesQuoteTemplateManageVersionsModalQuery, TemplatesQuoteTemplateManageVersionsModalQueryVariables> & ({ variables: TemplatesQuoteTemplateManageVersionsModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplatesQuoteTemplateManageVersionsModalQuery, TemplatesQuoteTemplateManageVersionsModalQueryVariables>(TemplatesQuoteTemplateManageVersionsModalDocument, options);
      }
export function useTemplatesQuoteTemplateManageVersionsModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplatesQuoteTemplateManageVersionsModalQuery, TemplatesQuoteTemplateManageVersionsModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplatesQuoteTemplateManageVersionsModalQuery, TemplatesQuoteTemplateManageVersionsModalQueryVariables>(TemplatesQuoteTemplateManageVersionsModalDocument, options);
        }
export function useTemplatesQuoteTemplateManageVersionsModalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TemplatesQuoteTemplateManageVersionsModalQuery, TemplatesQuoteTemplateManageVersionsModalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TemplatesQuoteTemplateManageVersionsModalQuery, TemplatesQuoteTemplateManageVersionsModalQueryVariables>(TemplatesQuoteTemplateManageVersionsModalDocument, options);
        }
export type TemplatesQuoteTemplateManageVersionsModalQueryHookResult = ReturnType<typeof useTemplatesQuoteTemplateManageVersionsModalQuery>;
export type TemplatesQuoteTemplateManageVersionsModalLazyQueryHookResult = ReturnType<typeof useTemplatesQuoteTemplateManageVersionsModalLazyQuery>;
export type TemplatesQuoteTemplateManageVersionsModalSuspenseQueryHookResult = ReturnType<typeof useTemplatesQuoteTemplateManageVersionsModalSuspenseQuery>;
export type TemplatesQuoteTemplateManageVersionsModalQueryResult = Apollo.QueryResult<TemplatesQuoteTemplateManageVersionsModalQuery, TemplatesQuoteTemplateManageVersionsModalQueryVariables>;